import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css';
import './assets/css/base.scss';
import {
  getToken,
  PromiseWidget
} from './assets/js/tools';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import waterfall from './components/vue-waterfall/index';
import VueParticles from 'vue-particles';
import VirtualCollection from 'vue-virtual-collection'

Vue.use(VirtualCollection)
Vue.use(waterfall);
Vue.use(ElementUI);
Vue.use(VueParticles);

Vue.config.productionTip = false

Vue.prototype.$bus = new Vue()

router.beforeEach(async (to, from, next) => {
  if (to.meta.auth) {
    const [err, ret] = await PromiseWidget.to(getToken());
    if (err) {
      if (sessionStorage.token) {
        next()
      } else {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        })
      }
    } else {
      sessionStorage.token = ret;
      next();
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
